export enum NationalEducationStatusEnum {
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  NOT_MEMBER = 'NOT_MEMBER',
  MEMBER = 'MEMBER',
  RETIRED = 'RETIRED'
}

export const nationalEducationStatusEnumMapping = {
  [NationalEducationStatusEnum.NOT_APPLICABLE]: 'Non applicable',
  [NationalEducationStatusEnum.NOT_MEMBER]: 'Non membre',
  [NationalEducationStatusEnum.MEMBER]: 'Membre',
  [NationalEducationStatusEnum.RETIRED]: 'Retraité'
}
